'use es6';

import BannerTemplate from 'cookie-banner/templates/BannerTemplate';
import Consent from 'cookie-banner/models/Consent';
import { CATEGORY_PREFERENCES_COOKIE, CATEGORY_PREFERENCES_COOKIE_EXPIRATION } from 'cookie-banner/constants/trackingCookies';
import { SCANNING_MODE_FLAG } from 'cookie-banner/constants/hspb';
export default class CookiesByCategoryHandler {
  constructor(privacyBanner, privacySettings) {
    this.privacyBanner = privacyBanner;
    this.privacySettings = privacySettings;
    this.bannerTemplate = new BannerTemplate(this.privacyBanner, this.privacySettings);
  }
  showModal() {
    this.bannerTemplate.displayModal();
    this.privacyBanner.sendReportingViewActivity();
  }
  handle() {
    const {
      cookie
    } = this.privacyBanner;
    const {
      testing
    } = this.privacySettings;
    if (this.privacyBanner.context.getWindow()[SCANNING_MODE_FLAG]) {
      this.privacyBanner.setPrivacyConsent(true);
      this.privacyBanner.cookie.set(CATEGORY_PREFERENCES_COOKIE, this.privacyBanner.privacyConsent.toCookieString(), {
        daysToExpire: CATEGORY_PREFERENCES_COOKIE_EXPIRATION,
        path: '/'
      });
      return;
    }
    const categoryPreferencesCookie = cookie.get(CATEGORY_PREFERENCES_COOKIE);
    if (categoryPreferencesCookie && !testing) {
      this.privacyBanner.setPrivacyConsent(Consent.buildFromCookieString(categoryPreferencesCookie));
      return;
    }
    this.bannerTemplate.render();
    this.privacyBanner.sendReportingViewActivity();
  }
}